// extracted by mini-css-extract-plugin
export default {"link":"GM-z","disabled":"HM-z"};